import React from "react";

/**
 * Compact inline sparkline for a series of scores (0-100).
 * `values` is chronological (oldest → newest).
 */
export default function Sparkline({ values, width = 120, height = 30, stroke = "var(--gold)" }) {
  const points = (values || []).filter((v) => typeof v === "number");
  if (points.length < 2) return null;
  const min = Math.min(...points, 0);
  const max = Math.max(...points, 100);
  const range = max - min || 1;
  const step = width / (points.length - 1);
  const path = points.map((v, i) => {
    const x = i * step;
    const y = height - ((v - min) / range) * height;
    return `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`;
  }).join(" ");
  const last = points[points.length - 1];
  const first = points[0];
  const trend = last === first ? "flat" : last > first ? "up" : "down";
  const trendColor = trend === "up" ? "#34d399" : trend === "down" ? "#ef4444" : "var(--text-secondary)";
  return (
    <div className="flex items-center gap-2" title={`${points.length} inspections · trend ${trend}`}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible">
        <path d={path} fill="none" stroke={stroke} strokeWidth="1.5"/>
        <circle cx={width} cy={height - ((last - min) / range) * height} r="2.5" fill={trendColor}/>
      </svg>
      <span className="text-[10px]" style={{ color: trendColor }}>
        {trend === "up" ? "▲" : trend === "down" ? "▼" : "▬"} {Math.abs(last - first).toFixed(0)}pt
      </span>
    </div>
  );
}
